import { css } from 'linaria';

export const imageContainer = css`
  position: absolute;
  top: var(--space-300);
  left: 50%;
  z-index: -1;
  padding: var(--space-200);
  box-shadow:
    0 12px 40px rgba(0, 0, 0, 0.08),
    0 0.751293px 10.0172px rgba(0, 0, 0, 0.035),
    0 0.399006px 5.32008px rgba(0, 0, 0, 0.0282725),
    0 0.166035px 2.21381px rgba(0, 0, 0, 0.0196802);
  transition: transform 0.3s;
`;

export const roundedLink = css`
  position: relative;
  overflow: hidden;

  &:hover {
    .${imageContainer} {
      transform: translateY(-8px);
    }
  }
`;
